import React, { ReactElement, useCallback, useMemo } from 'react';

import './WarningModal.css';
import StudioModal from 'Modules/Studio/components/StudioModal/StudioModal';
import ProgressIndicator from '@components/Blackbird/Forms/ProgressIndicator/ProgressIndicator';
import { modalPropDefaults, TErrorDetails, TWarningModalProps } from './WarningModal.constants';
import cn from 'utils/cn';
import WarningModalForm from './WarningModalForm';

const WarningModal: React.FC<TWarningModalProps> = ({
  progressProps,
  text,
  onCancel,
  onConfirm,
  onClose,
  hideCancelButton = false,
  modalProps,
  confirmBtnAsLink = false,
  confirmBtnLinkProps,
  showErrorDetails = false,
  errorDetails = {},
  showContinueText = true,
}): ReactElement<any> => {
  const showProgress = useMemo(
    () => progressProps?.isSaving || progressProps?.isSuccessful || progressProps?.hasError,
    [progressProps]
  );

  /**
   * handles calling the onClose, of onCancel functions that are passed into the props
   */
  const handleCloseModal = useCallback(() => {
    if (modalProps?.hideCloseButton === false && onClose) {
      onClose();
    } else if (onCancel) {
      onCancel();
    }
  }, [onClose, onCancel, modalProps]);

  return (
    <StudioModal
      showWarning
      hideCloseButton
      {...{
        ...modalPropDefaults,
        ...modalProps,
      }}
      closeModal={handleCloseModal}
    >
      <div className={cn('tw:relative', showProgress && 'tw:mt-[40px]')}>
        <ProgressIndicator
          isSaving={progressProps?.isSaving || false}
          hasError={progressProps?.hasError || false}
          savingMsg={progressProps?.savingMsg}
          errorMsg={progressProps?.errorMsg}
          successMsg={progressProps?.successMsg}
          isSuccessful={progressProps?.isSuccessful || false}
        />
      </div>

      <WarningModalForm
        {...{
          text,
          onConfirm,
          onCancel,
          hideCancelButton,
          modalProps,
          progressProps,
          confirmBtnAsLink,
          confirmBtnLinkProps,
          showErrorDetails,
          errorDetails: errorDetails as TErrorDetails,
          showContinueText,
        }}
      />
    </StudioModal>
  );
};

export default WarningModal;
